import { Component, inject, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { getUser, getAccount, State } from '@store'
import { OrganizationActions } from '@store/actions'
import { combineLatest, firstValueFrom } from 'rxjs'
import { filter } from 'rxjs/operators'
import { AssetViewStore } from './asset-list/asset-view.store'
import { AuthService } from './services'
import { BvAlertComponent } from './bv-alert'
import { RouterOutlet } from '@angular/router'
import { TraceService } from '@sentry/angular'

@Component({
  selector: 'my-app',
  template: `
    <bv-alert class="block fixed right-8 bottom-8 z-[1001]"></bv-alert>
    <router-outlet></router-outlet>
    <router-outlet name="overlay"></router-outlet>
  `,
  providers: [AssetViewStore],
  imports: [BvAlertComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private store = inject(Store<State>)
  private authService = inject(AuthService)
  private _traceService = inject(TraceService)

  async ngOnInit() {
    await this.authService.init()

    await firstValueFrom(
      combineLatest([this.store.select(getUser), this.store.select(getAccount)]).pipe(
        filter(([user, account]) => !!user && !!account && !this.authService.mustChangePassword(user.claims)),
      ),
    )
    this.store.dispatch(OrganizationActions.fetchOrganization())
    this.store.dispatch(OrganizationActions.fetchOrganizations())
    this.store.dispatch(OrganizationActions.fetchUsers())
  }
}
